export default {
  intro: 'Bitte folgen Sie den Anweisung auf dem Zahlungssystem auf Ihrer rechten Seite.',
};
